import { Any } from 'cosmjs-types/google/protobuf/any'

import { encodeInt64, encodeMessage, encodeString } from './proto'

export interface SubmitMultisigProposalParams {
  creator: string
  group: string
  messages: Any[]
}

// Explicit mapping for vote options used by the chain proto.
// Ensure these values match the chain's enum (if present):
//   0 -> NO (Reject)
//   1 -> YES (Approve)
export enum VoteOption {
  NO = 0,
  YES = 1,
}

export interface VoteMultisigProposalParams {
  creator: string
  proposalId: bigint
  option: VoteOption
}

function encodeAnyMessage(msg: Any): Uint8Array {
  const typeUrl = msg.typeUrl ?? ''
  const valueBytes = msg.value ?? new Uint8Array()

  return Uint8Array.from([
    ...encodeString(1, typeUrl),
    ...encodeMessage(2, valueBytes),
  ])
}

export function buildSubmitMultisigProposalMsg(
  params: SubmitMultisigProposalParams,
): Any {
  const parts: number[] = []

  parts.push(...encodeString(1, params.creator))
  parts.push(...encodeString(2, params.group))

  for (const message of params.messages) {
    parts.push(...encodeMessage(3, encodeAnyMessage(message)))
  }

  const value = Uint8Array.from(parts)

  return Any.fromPartial({
    typeUrl: '/core.multisig.MsgSubmitProposal',
    value,
  })
}

export function buildVoteMultisigProposalMsg(
  params: VoteMultisigProposalParams,
): Any {
  const parts: number[] = []

  parts.push(...encodeString(1, params.creator))
  parts.push(...encodeInt64(2, params.proposalId))
  parts.push(...encodeInt64(3, BigInt(params.option)))

  const value = Uint8Array.from(parts)

  return Any.fromPartial({
    typeUrl: '/core.multisig.MsgVote',
    value,
  })
}
